export default "__VITE_ASSET__JjotwpLQ__"